var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"passenger_box_two mt-2"},[_c('div',{staticClass:"passenger_body",staticStyle:{"background-image":"url(/assets/img/passenger-box-banner.jpg)"}},_vm._l((_vm.users),function(user,idx){return _c('UserInformation',{key:idx,attrs:{"index":idx,"user":user,"readOnly":_vm.readOnly},on:{"updateUser":_vm.updateUserInformation}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }